// extracted by mini-css-extract-plugin
export default {"banner":"offline-banner_banner__JcQua","dot":"offline-banner_dot__o7CqS","pulse":"offline-banner_pulse__Fq8sA"};